import React from "react";
import { Route, Switch } from "react-router-dom"

// import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import Affiliates from "./Affiliates/Affiliates";
import EditAffiliates from "./Affiliates/Edit/Edit";
import AddAffiliates from "./Affiliates/Add/Add";
import Audits from "./Audits/Audits";
import Documents from "./Documents/Documents";
import UnapprovedDocuments from "./Documents/UnapprovedDocuments";
import Editor from "./Documents/Editor/Editor";
import Player from "./Documents/Player/Player";
import Remediation from "./Remediation/Remediation";
import Add from "./Remediation/Add/Add";
import Edit from "./Remediation/Edit/Edit";
import Tasks from "./Tasks/Tasks";
import AddTask from "./Tasks/Add/Add";
import EditTask from "./Tasks/Edit/Edit";
import Training from "./Training/Training";
import TrainingEdit from "./Training/Training/Training";
import Audit from "./Audits/Audit/Audit";
import AuditDevice from "./Audits/Audit/AuditDevice";
import NotFound from "views/Welcome/NotFound";

const Achieve = props => {
    return (
        // Remove React.Fragment and uncomment ProtectedRoute when below routes are in use

        <React.Fragment>
            {/* <ProtectedRoute> */}

            {/* Switch Routes below */}
            <Switch>
                <Route
                    exact
                    path="/achieve/affiliates"
                    component={Affiliates}
                />
                <Route
                    exact
                    path="/achieve/affiliates/edit"
                    component={EditAffiliates}
                />
                <Route
                    exact
                    path="/achieve/affiliates/add"
                    component={AddAffiliates}
                />
                <Route exact path="/achieve/audits" component={Audits} />
                <Route path="/achieve/audits/audit" component={Audit} />
                <Route path="/achieve/audits/audit-device" component={AuditDevice} />
                <Route exact path="/achieve/documents" component={Documents} />
                <Route exact path="/achieve/unapproved-documents" component={UnapprovedDocuments} />
                <Route
                    exact
                    path="/achieve/documents/editor/:id/:mode"
                    component={Editor}
                />
                                <Route
                    exact
                    path="/achieve/documents/player/:id/"
                    component={Player}
                />
                <Route
                    exact
                    path="/achieve/remediation"
                    component={Remediation}
                />
                <Route exact path="/achieve/remediation/add" component={Add} />
                <Route
                    exact
                    path="/achieve/remediation/edit"
                    component={Edit}
                />
                <Route exact path="/achieve/tasks" component={Tasks} />
                <Route exact path="/achieve/tasks/add" component={AddTask} />
                <Route exact path="/achieve/tasks/edit/:taskId" component={EditTask} />
                <Route exact path="/achieve/training" component={Training} />
                <Route exact path="/achieve/training/edit" component={TrainingEdit} />
                <Route component={NotFound} />
            </Switch>

            {/* </ProtectedRoute> */}
        </React.Fragment>
    );
};

export default Achieve;
